module.exports = __webpack_public_path__ + "img/give-try-video.2b275752.jpg";